import reducerRegistry from './src/reducer-registry.js';

export default reducerRegistry;
